(() => {
  function updateDates() {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Stockholm', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const value = type => Number(parts.find(part => part.type === type).value);
    const date = new Date(Date.UTC(value('year'), value('month') - 1, value('day') + 3, 12));
    const label = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Stockholm', weekday: 'long', day: 'numeric', month: 'short' }).format(date);
    const day = date.getUTCDate();
    const suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({1: 'st', 2: 'nd', 3: 'rd'}[day % 10] || 'th');
    const arrival = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'long' }).format(date) + ' ' + day + suffix;
    document.querySelectorAll('[data-arrival-date]').forEach(el => { el.textContent = arrival; });
    document.querySelectorAll('[data-arrival-message]').forEach(el => { el.hidden = false; });
    document.querySelectorAll('[data-dispatch-date]').forEach(el => { el.textContent = label; });
  }
  updateDates();
  document.addEventListener('shopify:section:load', updateDates);
})();
